export default __webpack_public_path__ + "static/media/lb-m-banner.42ae00fb.webp";